module.exports = __webpack_public_path__ + "static/media/md-person.d5374614.svg";